import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { SignOrderResponse, SignOrderStatus } from "./types/SignOrderResponse";

import { SignOrderRequest } from "./types/SignOrderRequest";
import { UpdateSignOrderRequest } from "./types/UpdateSignOrderRequest";

export interface SigningState {
  loading: boolean;
  order: SignOrderResponse;
  error: string;
}

const initialState: SigningState = {
  loading: false,
  order: {
    orderId: "",
    signingReference: "",
    edhSigningReference: "",
    signingUrl: "",
    status: SignOrderStatus.NOT_CREATED,
  },
  error: "",
};

const signingSlice = createSlice({
  name: "signing",
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    requestSigningOrder: (
      state: SigningState,
      action: PayloadAction<SignOrderRequest>,
    ) => {
      state.loading = true;
    },
    requestSigningOrderSuccessful: (
      state: SigningState,
      action: PayloadAction<SignOrderResponse>,
    ) => {
      state.loading = false;
      state.order = action.payload;
    },
    requestSigningOrderFailed: (
      state: SigningState,
      action: PayloadAction<string>,
    ) => {
      state.error = action.payload;
      state.loading = false;
    },

    requestCreateSigningOrder: (
      state: SigningState,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      action: PayloadAction<SignOrderRequest>,
    ) => {
      state.loading = true;
      state.error = "";
    },
    requestCreateSigningOrderSuccessful: (
      state: SigningState,
      action: PayloadAction<SignOrderResponse>,
    ) => {
      state.order.status = action.payload.status;
      state.loading = false;
    },
    requestCreateSigningOrderFailed: (
      state: SigningState,
      action: PayloadAction<string>,
    ) => {
      state.error = action.payload;
      state.loading = false;
    },

    requestSigningCompleted: (
      state: SigningState,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      action: PayloadAction<UpdateSignOrderRequest>,
    ) => {
      state.loading = true;
    },
    requestSigningCompletedSuccessful: (
      state: SigningState,
      action: PayloadAction<SignOrderResponse>,
    ) => {
      state.loading = false;
      state.order = action.payload;
    },
    requestSigningCompletedFailed: (
      state: SigningState,
      action: PayloadAction<any>,
    ) => {
      state.loading = false;
      state.error = action.payload;
    },

    requestSigningAborted: (
      state: SigningState,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      action: PayloadAction<UpdateSignOrderRequest>,
    ) => {
      state.loading = true;
    },
    requestSigningAbortedSuccessful: (
      state: SigningState,
      action: PayloadAction<SignOrderResponse>,
    ) => {
      state.loading = false;
      state.order = action.payload;
    },
    requestSigningAbortedFailed: (
      state: SigningState,
      action: PayloadAction<string>,
    ) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { actions } = signingSlice;
export default signingSlice.reducer;
export const {
  requestCreateSigningOrder,
  requestSigningAborted,
  requestSigningCompleted,
  requestSigningOrder,
} = actions;
export { initialState };
